import { 
  ADD_PROJECT,
  SET_PROJECTS,
  DELETE_PROJECT,
  UPDATE_PROJECT,
  SET_PROJECT,
  ADD_DATABASE,
  GET_DATABASE,
  UPDATE_DATABASE,
  DELETE_DATABASE,
  ADD_BACKEND_SERVICE,
  ADD_FRONTEND_APP,
  SET_BACKEND_SERVICE,
  SET_FRONTEND_APP,
  DELETE_BACKEND_SERVICE,
  DELETE_FRONTEND_APP,
  UPDATE_BACKEND_SERVICE,
  UPDATE_FRONTEND_APP,
  ADD_BRANCH_TO_FRONTEND_APP,
  UPDATE_BRANCH_IN_FRONTEND_APP,
  DELETE_BRANCH_FROM_FRONTEND_APP,
  UPDATE_FRONTEND_APP_ENVIRONMENT_VARIABLES,
  UPDATE_FRONTEND_APP_BRANCH_ENVIRONMENT_VARIABLES
} from "../constants/actionTypes";
import {apiClient} from '../utils/apiClient';
import { updateProjectRole } from "./users";

export const fetchProjects = () => async (dispatch) => {
  try {
    const data = await apiClient.get('/all',{
      requiredPermission: 'view:projects'
    });
    dispatch({ type: SET_PROJECTS, payload: data });
  } catch (error) {
    console.error('Error fetching projects:', error);
  }
};

export const createProject = (projectData, userId) => async (dispatch) => {
  try {
    const data = await apiClient.post('/',{
      projectName: projectData.Name,
      environment: projectData.Environment
    }, {
      requiredPermission: 'create:project'
    });
    if (data && data.projectId) {
      // const currentUser = useSelector(state => state.auth.user);
      // const userId = getState().auth.user?.userId;
      // const userId = currentUser?.userId;
      dispatch({ type: ADD_PROJECT, payload: data });
      if (userId) {
        // Automatically assign the user as an admin of the new project
        await dispatch(updateProjectRole(userId, data.projectId, 'admin'));
      }
      return data?.projectId;
    }
    return null;
  } catch (error) {
    console.error('Error creating project:', error);
  }
};

export const deleteProject = (projectId) => async (dispatch) => {
  try {
    const data = await apiClient.delete(`/${projectId}`, {
      projectId,
      requiredPermission: 'delete:project'
    });
    if (data) {
      dispatch({ type: DELETE_PROJECT, payload: projectId });
    }
  } catch (error) {
    console.error('Error deleting project:', error);
  }
};

export const updateProject = (projectId, projectData) => async (dispatch) => {
  try {
    const data = await apiClient.put(`/${projectId}`, {
      projectName: projectData.Name,
      environment: projectData.Environment
    }, {
      projectId,
      requiredPermission: 'update:project'
    });
    if (data) {
      dispatch({ type: UPDATE_PROJECT, payload: data });
    }
  } catch (error) {
    console.error('Error updating project:', error);
  }
};

export const setProject = (projectId) => async (dispatch) => {
  try {
    const data = await apiClient.get(`/${projectId}`, {
      projectId,
      requiredPermission: 'view:project'
    });
    if (data) {
      dispatch({ type: SET_PROJECT, payload: data });
      return data?.projectId;
    }
    return null;
  } catch (error) {
    console.error('Error setting project:', error);
    return null;
  }
};

export const addBackendService = (projectId, serviceData) => async (dispatch) => {
  try {
    const data = await apiClient.post(`/${projectId}/service`, serviceData, {
      projectId,
      requiredPermission: 'create:backend_service'
    });
    
    if (data) {
      dispatch({ type: ADD_BACKEND_SERVICE, payload: data });
      return data?.serviceId;
    }
    return null;
  } catch (error) {
    console.error('Error adding backend service:', error);
    return null;
  }
};

export const updateBackendService = (projectId, serviceId, serviceData) => async (dispatch) => {
  try {
    const data = await apiClient.put(`/${projectId}/service/${serviceId}`, serviceData, {
      projectId,
      resourceId: serviceId,
      resourceType: 'BACKEND_SERVICE',
      requiredPermission: 'update:backend_service'
    });
    if (data) {
      dispatch({ type: UPDATE_BACKEND_SERVICE, payload: data });
      return data?.serviceId;
    }
    return null;
  } catch (error) {
    console.error('Error updating backend service:', error);
  }
};

export const deleteBackendService = (projectId, serviceId) => async (dispatch) => {
  try {
    const data = await apiClient.delete(`/${projectId}/service/${serviceId}`, {
      projectId,
      resourceId: serviceId,
      resourceType: 'BACKEND_SERVICE',
      requiredPermission: 'delete:backend_service'
    });
    if (data) {
      dispatch({ type: DELETE_BACKEND_SERVICE, payload: serviceId });
    }
  } catch (error) {
    console.error('Error deleting backend service:', error);
  }
};

export const addFrontendApp = (projectId, appData) => async (dispatch) => {
  try {
    const data = await apiClient.post(`/${projectId}/frontend-app`, appData, {
      projectId,
      requiredPermission: 'create:frontend_app'
    });
    if (data) {
      dispatch({ type: ADD_FRONTEND_APP, payload: data });
      return data?.appId;
    }
    return null;
  } catch (error) {
    console.error('Error adding frontend app:', error);
    return null;
  }
};

export const updateFrontendApp = (projectId, appId, appData) => async (dispatch) => {
  try {
    const data = await apiClient.put(`/${projectId}/frontend-app/${appId}`, appData, {
      projectId,
      resourceId: appId,
      resourceType: 'FRONTEND_APP',
      requiredPermission: 'update:frontend_app'
    });
    if (data) {
      dispatch({ type: UPDATE_FRONTEND_APP, payload: data });
    }
  } catch (error) {
    console.error('Error updating frontend app:', error);
  }
};

export const deleteFrontendApp = (projectId, appId) => async (dispatch) => {
  try {
    const data = await apiClient.delete(`/${projectId}/frontend-app/${appId}`, {
      projectId,
      resourceId: appId,
      resourceType: 'FRONTEND_APP',
      requiredPermission: 'delete:frontend_app'
    });
    if (data) {
      dispatch({ type: DELETE_FRONTEND_APP, payload: appId });
    }
  } catch (error) {
    console.error('Error deleting frontend app:', error);
  }
};  



export const addDatabase = (projectId, databaseData) => async (dispatch) => {
  try {
    const data = await apiClient.post(`/${projectId}/database`, databaseData, {
      projectId,
      requiredPermission: 'create:database'
    });
    if (data) {
      dispatch({ type: ADD_DATABASE, payload: data });
      return data?.databaseId;
    }
    return null;
  } catch (error) {
    console.error('Error adding database:', error);
    return null;
  }
};

export const updateDatabase = (projectId, databaseId, databaseData) => async (dispatch) => {
  try {
    const data = await apiClient.put(`/${projectId}/database/${databaseId}`, databaseData, {
      projectId,
      resourceId: databaseId,
      resourceType: 'DATABASE',
      requiredPermission: 'update:database'
    });
    if (data) {
      dispatch({ type: UPDATE_DATABASE, payload: data });
    }
  } catch (error) {
    console.error('Error updating database:', error);
  }
};

export const deleteDatabase = (projectId, databaseId) => async (dispatch) => {
  try {
    const data = await apiClient.delete(`/${projectId}/database/${databaseId}`, {
      projectId,
      resourceId: databaseId,
      resourceType: 'DATABASE',
      requiredPermission: 'delete:database'
    });
    if (data) {
      dispatch({ type: DELETE_DATABASE, payload: databaseId });
    }
  } catch (error) {
    console.error('Error deleting database:', error);
  }
};

export const getDatabase = (projectId, databaseId) => async (dispatch) => {
  try {
    const data = await apiClient.get(`/${projectId}/database/${databaseId}`, {
      projectId,
      resourceId: databaseId,
      resourceType: 'DATABASE',
      requiredPermission: 'view:database'
    });
    if (data) {
      dispatch({ type: GET_DATABASE, payload: data });
      return data?.databaseId;
    }
    return null;
  } catch (error) {
    console.error('Error setting database:', error);
    return null;
  }
};



export const getBackendService = (projectId, serviceId) => async (dispatch) => {
  try {
    const data = await apiClient.get(`/${projectId}/service/${serviceId}`, {
      projectId,
      resourceId: serviceId,
      resourceType: 'BACKEND_SERVICE',
      requiredPermission: 'view:backend_service'
    });
    if (data) {
      dispatch({ type: SET_BACKEND_SERVICE, payload: data });
      return data?.serviceId;
    }
    return null;
  } catch (error) {
    console.error('Error setting backend service:', error);
    return null;
  }
};

export const setFrontendApp = (projectId, appId) => async (dispatch) => {
  try {
    const data = await apiClient.get(`/${projectId}/frontend-app/${appId}`, {
      projectId,
      resourceId: appId,
      resourceType: 'FRONTEND_APP',
      requiredPermission: 'view:frontend_app'
    });
    if (data) {
      dispatch({ type: SET_FRONTEND_APP, payload: data });
      return data?.appId;
    }
    return null;
  } catch (error) {
    console.error('Error setting frontend app:', error);
    return null;
  }
};

export const addBranchToFrontendApp = (projectId,appId, branchData) => async (dispatch) => {
  try {
    const data = await apiClient.post(`/${projectId}/frontend-app/${appId}/branches`, branchData, {
      projectId,
      resourceId: appId,
      resourceType: 'FRONTEND_APP',
      requiredPermission: 'create:branch'
    });
    if (data) {
      dispatch({ type: ADD_BRANCH_TO_FRONTEND_APP, payload: data });
      return data?.branchId;
    }
    return null;
  } catch (error) {
    console.error('Error adding branch to frontend app:', error);
    return null;
  }
};

export const deleteBranchFromFrontendApp = (projectId,appId, branchId) => async (dispatch) => {
  try {
    const data = await apiClient.delete(`/${projectId}/frontend-app/${appId}/branches/${branchId}`, {
      projectId,
      resourceId: appId,
      resourceType: 'FRONTEND_APP',
      requiredPermission: 'delete:branch'
    });
    if (data) {
      dispatch({ type: DELETE_BRANCH_FROM_FRONTEND_APP, payload: branchId });
    }
  } catch (error) {
    console.error('Error deleting branch from frontend app:', error);
  }
};

export const updateBranchInFrontendApp = (projectId,appId, branchId, branchData) => async (dispatch) => {
  try {
    const data = await apiClient.put(`/${projectId}/frontend-app/${appId}/branches/${branchId}`, branchData, {
      projectId,
      resourceId: appId,
      resourceType: 'FRONTEND_APP',
      requiredPermission: 'update:branch'
    });
    if (data) {
      dispatch({ type: UPDATE_BRANCH_IN_FRONTEND_APP, payload: data });
    }
  } catch (error) {
    console.error('Error updating branch in frontend app:', error);
  }
};

export const updateFrontendAppEnvironmentVariables = (projectId,appId, environmentVariables) => async (dispatch) => {
  try {
    const data = await apiClient.put(`/${projectId}/frontend-app/${appId}/environment-variables`, {envVars: environmentVariables}, {
      projectId,
      resourceId: appId,
      resourceType: 'FRONTEND_APP',
      requiredPermission: 'update:env_vars'
    });
    if (data) {
      dispatch({ type: UPDATE_FRONTEND_APP_ENVIRONMENT_VARIABLES, payload: data });
      return data;
    }
  } catch (error) {
    console.error('Error updating frontend app environment variables:', error);
  }
};

export const updateFrontendAppBranchEnvironmentVariables = (projectId,appId, branchId, environmentVariables) => async (dispatch) => {
  try {
    const data = await apiClient.put(`/${projectId}/frontend-app/${appId}/branches/${branchId}/environment-variables`, environmentVariables, {
      projectId,
      resourceId: appId,
      resourceType: 'FRONTEND_APP',
      requiredPermission: 'update:branch_env_vars'
    });
    if (data) {
      dispatch({ type: UPDATE_FRONTEND_APP_BRANCH_ENVIRONMENT_VARIABLES, payload: data });
    }
  } catch (error) {
    console.error('Error updating frontend app branch environment variables:', error);
  }
};
